<template>
  <div class="slider">
    <div class="slider-title">
      <h4>Rate how you feel about your curls right now.</h4>
    </div>
    <div class="slider-body">
      <vue-slider
        v-model="value"
        :data="data"
        :marks="true"
      />
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: "Rate",
  components: {
    VueSlider
  },
  data() {
    return {
      value: 'awful',
      data: ['awful', 'bad', 'okay', 'good', 'great']
    }
  },
  watch: {
    value(val) {
      this.$emit('rate', val);
    }
  },
  created() {

  },
  methods: {

  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/AddCurlStatus/steps/Rate.vue